<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title" title="SalaryPaymentList">薪酬发放</li>
      <div
        class="flex align-center"
        v-if="state.select_count > 0"
        style="
          align-items: center;
          font-size: 90%;
          line-height: 13px;
          color: #7a7a7a;
        "
      >
        已选：
        <strong style="color: #1e90ff; margin-right: 3px; font-size: 100%">
          {{ state.select_count }}
        </strong>
        单，合计
        <strong style="color: #080; margin-right: 3px">
          {{ state.select_total?.employee_num }}
        </strong>
        笔 ，合计金额：
        <c_money
          :value="state.select_total?.money"
          style="font-weight: 600"
          :size="16"
        />
        <el-button
          type="danger"
          link
          @click="onClearSelect"
          style="margin-left: 5px"
        >
          清空
        </el-button>
      </div>
      <el-button
        type="primary"
        :icon="Money"
        link
        @click="state.showShouDong = true"
        :disabled="!state.select_count"
        v-if="$judge_auth('652')"
      >
        手动发放
      </el-button>
      <el-button
        type="primary"
        :icon="VideoPlay"
        link
        @click="onStarts"
        :disabled="!state.select_count"
        v-if="$judge_auth('648')"
      >
        开始发放
      </el-button>
      <el-button
        type="warning"
        :icon="OfficeBuilding"
        link
        @click="onYinQi"
        :disabled="!state.select_count"
        v-if="$judge_auth('653')"
      >
        银企发放
      </el-button>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onExport"
        v-if="$judge_auth('814')"
        size="large"
        >导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <c_statusradiogroup
        v-model="state.params.status"
        arrName="salarypayment_status"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="名称、单号、工资表单号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-input
        v-model="state.params.keywords_employee"
        style="width: 200px"
        placeholder="员工姓名、手机号、证件号"
        clearable
        @clear="
          delete state.params.keywords_employee;
          onLoad();
        "
        @paste.enter="
          $onKeywordsPaste($event, state.params, 'keywords_employee')
        "
      ></el-input>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 200px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-date-picker
        v-model="state.params.month"
        type="month"
        format="YYYY年M月"
        value-format="YYYY-MM"
        placeholder="薪资所属期"
        style="width: 140px"
      />
      <li style="width: 300px">
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="发放日期"
          end-placeholder="发放日期"
          value-format="YYYY-MM-DD"
          style="width: 100%"
          @change="
            (value) => {
              if (value) state.params.pay_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.pay_date;
          "
        />
      </li>
      <li style="width: 300px">
        <el-date-picker
          v-model="state.real_pay_dates"
          type="daterange"
          range-separator="至"
          start-placeholder="实际发薪日期"
          end-placeholder="实际发薪日期"
          value-format="YYYY-MM-DD"
          style="width: 100%"
          @change="
            (value) => {
              if (value)
                state.params.real_pay_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.real_pay_dates;
            delete state.params.real_pay_date;
          "
        />
      </li>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        row-key="id"
        @sort-change="onSortChange"
        @selection-change="onSelectChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" reserve-selection />
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态/发放单号" sortable="status" width="120">
          <template #default="{ row }">
            <c_tabgroup :value2="row.order_id">
              <template #top>
                <component
                  :is="$statusFormat2('salarypayment_status', row.status)"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="工资单号/名称"
          :formatter="
            (row) => $tab_GroupFormat(row.payroll_order_id, row.name || '')
          "
          min-width="220"
        >
        </el-table-column>
        <el-table-column
          label="所属客户/扣缴义务人"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.customer_name || '-',
                row.withholding_agent_name || '',
              )
          "
          min-width="220"
        />
        <el-table-column
          prop="month"
          label="薪资所属期"
          :formatter="$tab_TextFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="pay_date"
          sortable="pay_date"
          label="约定发薪日期"
          :formatter="$tab_TextFormat"
          align="center"
          :min-width="120"
        >
          <template #default="{ row }">
            <text
              :style="{
                color:
                  row.status == 0 &&
                  $dayjs(row.pay_date + ' 00:00:00') > $dayjs()
                    ? '#f00'
                    : '',
              }"
              >{{ row.pay_date }}</text
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="real_pay_date"
          sortable="real_pay_date"
          label="实际发薪日期"
          :formatter="$tab_TextFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="payed_money"
          sortable="payed_money"
          label="已发放金额"
          :formatter="$tab_PriceFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="money"
          label="本次发放金额"
          :formatter="$tab_MoneyFormat"
          align="center"
          :min-width="160"
        />
        <el-table-column
          prop="employee_num"
          label="本次发放数量"
          :formatter="$tab_NumberFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="payed_num"
          label="成功数"
          :formatter="$tab_NumberFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="failure_num"
          label="失败数"
          :formatter="$tab_NumberFormat"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="interface_paying_num"
          label="银企发放中"
          :formatter="$tab_NumberFormat"
          align="center"
          :min-width="120"
        />
        <!-- <el-table-column
          label="银企发放数量"
          min-width="160"
          sortable="interface_status"
          align="center"
        >
          <template #default="{ row }">
            <div v-if="row.interface_status == 0">-</div>
            <div v-else>
              <el-tag type="primary"
                >发放中：{{ row.interface_paying_num }}</el-tag
              >
              <el-tag type="success" style="margin: 5px 0"
                >成功数：{{ row.interface_payed_num }}</el-tag
              >
              <el-tag type="danger"
                >失败数：{{ row.interface_failure_num }}</el-tag
              >
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          label="操作"
          :width="220"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              v-if="[1, 2].includes(row.status) && $judge_auth('132')"
              @click.stop="
                $store.commit('openMenu', {
                  path: 'SalaryPaymentDetail',
                  title: '薪资发放单',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              操作
            </el-button>
            <el-button
              type="primary"
              link
              icon="Search"
              v-else
              @click.stop="
                $store.commit('openMenu', {
                  path: 'SalaryPaymentDetail',
                  title: '薪资发放单',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              查看
            </el-button>
            <el-button
              type="primary"
              link
              icon="Money"
              v-if="row.status === 0 && $judge_auth('648')"
              @click.stop="onStart(row)"
            >
              开始发放
            </el-button>
            <!-- <el-button
              type="warning"
              link
              icon="SwitchButton"
              v-if="row.status === 1 && $judge_auth('649')"
              @click="onBack(row)"
            >
              撤回发放
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showWithholdingAgent"
      title="选择扣缴义务人"
      @close="state.showWithholdingAgent = false"
    >
      <c_WithholdingAgentSelect
        @close="
          (arr) => {
            state.withholding_agent_arr = arr;
            state.showWithholdingAgent = false;
          }
        "
        :selectItems="state.withholding_agent_arr"
      ></c_WithholdingAgentSelect>
    </c_popup>
  </transition>
  <el-dialog
    v-model="state.showShouDong"
    title="手动发放"
    width="400px"
    align-center
  >
    <div
      class="flex align-center"
      v-if="state.select_count > 0"
      style="align-items: center; line-height: 13px; color: #7a7a7a"
    >
      已选：
      <strong style="color: #1e90ff; margin-right: 3px; font-size: 100%">
        {{ state.select_count }}
      </strong>
      单，合计
      <strong style="color: #080; margin-right: 3px">
        {{ state.select_total?.employee_num }}
      </strong>
      笔 ，合计金额：
      <c_money
        :value="state.select_total?.money"
        style="font-weight: 600"
        :size="16"
      />
    </div>
    <el-form
      :model="state.sdModel"
      ref="formDom"
      style="width: 100%; margin-top: 20px"
    >
      <el-form-item
        label="实际发薪日期"
        prop="real_pay_date"
        :rules="[
          {
            required: true,
            message: '请选择实际发薪日期',
            trigger: 'blur',
          },
        ]"
      >
        <el-date-picker
          v-model="state.sdModel.real_pay_date"
          type="date"
          placeholder="实际发薪日期"
          size="large"
          value-format="YYYY-MM-DD"
        />
      </el-form-item>
    </el-form>
    <ul style="text-align: right; margin-top: 40px">
      <el-button
        type="primary"
        @click="onSubmitShouDong"
        size="large"
        style="width: 100%"
      >
        提交
      </el-button>
    </ul>
  </el-dialog>
  <el-dialog
    v-model="state.showYinQi"
    title="银企发放"
    width="500px"
    align-center
  >
    <div
      class="flex align-center"
      v-if="state.select_count > 0"
      style="align-items: center; line-height: 13px; color: #7a7a7a"
    >
      已选：
      <strong style="color: #1e90ff; margin-right: 3px; font-size: 100%">
        {{ state.select_count }}
      </strong>
      单，合计
      <strong style="color: #080; margin-right: 3px">
        {{ state.select_total?.employee_num }}
      </strong>
      笔 ，合计金额：
      <c_money
        :value="state.select_total?.money"
        style="font-weight: 600"
        :size="16"
      />
    </div>
    <el-form
      :model="state.payModel"
      ref="formDom"
      style="width: 100%; margin-top: 10px"
    >
      <el-form-item
        label="发放账户"
        prop="bank_account_pay"
        :rules="[
          {
            required: true,
            message: '请选择发放账户',
            trigger: 'blur',
          },
        ]"
      >
        <el-select
          v-model="state.payModel.bank_account_pay"
          placeholder="请选择发放账户"
          size="large"
          popper-class="custom-select-auto-height"
          value-key="id"
        >
          <el-option
            v-for="item in state.bank_account_data"
            :key="item"
            :value="item"
            :label="item.name + item.bank"
          >
            <div style="padding: 5px 0">
              <ul style="display: flex; align-items: center">
                <li style="flex: 1">
                  {{ item.name }}
                </li>
                <text v-if="item.bank" style="color: #a2a2a2; font-size: 90%">
                  {{ item.bank }}
                </text>
              </ul>
              <ul style="color: #a2a2a2; font-size: 90%; margin-top: 3px">
                {{
                  item.account
                }}
              </ul>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="发放摘要"
        prop="furinfo"
        :rules="[
          {
            required: state.payModel.bank_account_pay?.b2e_type == 'boc',
            message: '请选择发放摘要',
            trigger: 'blur',
          },
        ]"
      >
        <el-select
          v-model="state.payModel.furinfo"
          placeholder="请选择发放摘要"
          size="large"
        >
          <el-option
            v-for="item in state.bocfurinfo_data"
            :key="item"
            :value="item.value"
            :label="item.name"
          ></el-option>
          <template #footer>
            <el-button size="small" @click="onLoadBocFurInfo()">刷新</el-button>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item
        label="制单人"
        v-if="state.payModel.bank_account_pay?.b2e_type == 'cmbc'"
        prop="generate_order_user"
        :rules="[
          {
            required: true,
            message: '请选择制单人',
            trigger: 'blur',
          },
        ]"
      >
        <el-select
          v-model="state.payModel.generate_order_user"
          placeholder="请选择制单人"
          size="large"
        >
          <el-option
            v-for="item in state.cmbcgenerateorderuser_data"
            :key="item"
            :value="item.name"
            :label="item.name"
          ></el-option>
          <template #footer>
            <el-button size="small" @click="onLoadBocFurInfo()">刷新</el-button>
          </template>
        </el-select>
      </el-form-item>
    </el-form>
    <ul style="text-align: right; margin-top: 40px">
      <el-button
        type="primary"
        @click="onSubmitYinQi"
        size="large"
        style="width: 100%"
      >
        提交
      </el-button>
    </ul>
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  salarypayment_list,
  salarypayment_manualpay,
  salarypayment_b2epay,
  salarypayment_startpay,
  salarypayment_cancelpay,
  salarypayment_export,
} from "@/http/salarypayment";
import {
  data_b2edictionary_getbocfurinfo,
  data_withholdingagent_account,
  data_getcmbcgenerateorderuser,
} from "@/http/data";
import { data_customer_select } from "@/http/data";
import { ElMessageBox, ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const formDom = ref(null);
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      payModel: {},
      sdModel: {},
    });
    onMounted(() => {
      onLoadCustomer();
      onLoad();
      onLoadBocFurInfo();
      onLoadCmbcGenerateOrderUser();
    });

    const onLoadBocFurInfo = () => {
      data_b2edictionary_getbocfurinfo().then((res) => {
        if (res.status == 200) {
          state.bocfurinfo_data = res.data.data;
        }
      });
    };

    const onLoadCmbcGenerateOrderUser = () => {
      data_getcmbcgenerateorderuser().then((res) => {
        if (res.status == 200) {
          state.cmbcgenerateorderuser_data = res.data.data;
        }
      });
    };

    const onLoad = () => {
      delete state.tableData;

      salarypayment_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    const onDateChange = (value) => {
      if (value) state.params.pay_date = value[0] + " - " + value[1];
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onRowClick = (item) => {
      tableDom.value.toggleRowSelection(item);
    };

    //选择项改变事件
    const onSelectChange = (rows) => {
      state.select_count = rows.length;
      let msg;
      if (rows?.length > 0) {
        const item = rows.reduce(
          (item, cur) => {
            item.employee_num += cur.employee_num;
            item.money += parseFloat(cur.money);
            return item;
          },
          {
            employee_num: 0,
            money: 0,
          },
        );
        state.select_total = item;
      }
      state.selectMsg = msg;
    };

    //清空已选
    const onClearSelect = () => {
      tableDom.value.clearSelection();
      state.select_count = 0;
    };

    //手动发放
    const onSubmitShouDong = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择发放单",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${rows.length}</strong>条数据，是否确认<strong style='color:#1e90ff'>手动发放</strong>？`,
        "手动发放",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定发放",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        salarypayment_manualpay({
          id: rows.map((m) => m.id).join(","),
          real_pay_date: state.sdModel.real_pay_date,
        }).then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert(res.data.msg, "提示", {
              dangerouslyUseHTMLString: true,
              type: "success",
              callback: () => {
                state.payModel = {};
                onLoad();
              },
            });
          }
        });
      });
    };

    const onSelectCount = () => {
      return tableDom.value.getSelectionRows()?.length || 0;
    };

    //银企发放
    const onYinQi = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择发放单",
          grouping: true,
        });
        return false;
      }

      const withholding_agent_id = rows[0].withholding_agent_id;

      if (rows.some((s) => s.withholding_agent_id != withholding_agent_id)) {
        ElMessage.warning("请选择同一扣缴义务人的发薪单进行发放！");
        return false;
      }

      data_withholdingagent_account({
        withholding_agent_id,
      }).then((res) => {
        if (res.status == 200) {
          state.bank_account_data = res.data?.data?.list;
          state.showYinQi = true;
        }
      });
    };

    const onSubmitYinQi = () => {
      formDom.value.validate((valid, rules) => {
        if (valid) {
          const rows = tableDom.value.getSelectionRows();
          ElMessageBox.confirm(
            `您本次选择了<strong style='color:#f00'>${rows.length}</strong>条数据，是否确认<strong style='color:#ffa500'>调用银企发放</strong>？`,
            "银企发放",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定发放",
              cancelButtonText: "取消",
              type: "warning",
            },
          ).then(() => {
            salarypayment_b2epay({
              id: rows.map((m) => m.id).join(","),
              bank_account_pay_id: state.payModel?.bank_account_pay?.id,
              furinfo: state.payModel.furinfo,
              generate_order_user: state.payModel?.generate_order_user,
            }).then((res) => {
              if (res.status == 200) {
                ElMessageBox.alert(res.data.msg, "提示", {
                  dangerouslyUseHTMLString: true,
                  type: "success",
                  callback: () => {
                    onLoad();
                  },
                });
              }
            });
          });
        } else {
          ElMessage({
            type: "warning",
            grouping: true,
            message: rules[Object.keys(rules)[0]][0]?.message,
          });
        }
      });
    };

    //开始发放
    const onStart = (row) => {
      ElMessageBox.confirm(
        `您确定开始发放单号为<strong style='color:#1e90ff'>${row.order_id}</strong>的发放单吗？`,
        "开始发放",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定发放",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        salarypayment_startpay({ id: row.id }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //批量开始发放
    const onStarts = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length > 0) {
        ElMessageBox.confirm(
          `您本次选择了<strong style='color:#f00'>${rows.length}</strong>条数据，是否确认<strong style='color:#1e90ff'>批量开始发放</strong>？`,
          "批量开始发放",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定发放",
            cancelButtonText: "取消",
            type: "warning",
          },
        ).then(() => {
          salarypayment_startpay({ id: rows.map((m) => m.id).join(",") }).then(
            (res) => {
              if (res.status == 200) {
                ElMessage.success(res.data.msg);
                onLoad();
              }
            },
          );
        });
      }
    };

    //撤回发放
    const onBack = (row) => {
      ElMessageBox.confirm(
        `您确定撤回单号为<strong style='color:#f00'>${row.order_id}</strong>的发放单吗？`,
        "撤回发放",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定撤回",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        salarypayment_cancelpay({ id: row.id }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      salarypayment_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onDateChange,
      tableDom,
      onRowClick,
      onYinQi,
      onSubmitYinQi,
      onStart,
      onStarts,
      onBack,
      onSelectCount,
      onLoadBocFurInfo,
      formDom,
      onExport,
      onSelectChange,
      onClearSelect,
      onSubmitShouDong,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
